import { axiosPrivate } from "./axios";

/**
 * Employee Requests (admin side). Admins can list/view, change status and reply.
 */
const employeeRequestService = {
  list: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null),
    );
    const { data } = await axiosPrivate.get("/api/employee-requests/admin", { params: clean });
    // Normalised for useInfiniteList.
    return { items: data.requests, pagination: data.pagination, unreadCount: data.unreadCount, stats: data.stats };
  },

  get: async (id) => {
    const { data } = await axiosPrivate.get(`/api/employee-requests/admin/${id}`);
    return data.request;
  },

  updateStatus: async (id, status) => {
    const { data } = await axiosPrivate.patch(`/api/employee-requests/admin/${id}/status`, { status });
    return data.request;
  },

  /** Text, files, or both (files go as multipart under the "files" field). */
  reply: async (id, message, files = []) => {
    let body = { message };
    if (files.length) {
      body = new FormData();
      body.append("message", message);
      files.forEach((f) => body.append("files", f));
    }
    const { data } = await axiosPrivate.post(`/api/employee-requests/admin/${id}/replies`, body);
    return data.request;
  },

  editReply: async (id, replyId, message) => {
    const { data } = await axiosPrivate.patch(`/api/employee-requests/admin/${id}/replies/${replyId}`, { message });
    return data.request;
  },

  deleteReply: async (id, replyId) => {
    const { data } = await axiosPrivate.delete(`/api/employee-requests/admin/${id}/replies/${replyId}`);
    return data.request;
  },

  /** Clears the "new activity" indicator for this request. */
  markRead: async (id) => {
    const { data } = await axiosPrivate.post(`/api/employee-requests/admin/${id}/read`);
    return data.request;
  },

  /** Number of requests with employee activity nobody has opened yet. */
  unreadCount: async () => {
    const { data } = await axiosPrivate.get("/api/employee-requests/admin", { params: { limit: 1 } });
    return data.unreadCount || 0;
  },

  /** Default To / CC / subject for emailing the employee about this request. */
  emailDraft: async (id) => {
    const { data } = await axiosPrivate.get(`/api/employee-requests/admin/${id}/email-draft`);
    return data.draft;
  },

  sendEmail: async (id, payload) => {
    const { data } = await axiosPrivate.post(`/api/employee-requests/admin/${id}/email`, payload);
    return data;
  },

  /** Attachments are auth-protected, so fetch as a blob and render via object URL. */
  fetchAttachment: async (url) => {
    const { data } = await axiosPrivate.get(url, { responseType: "blob" });
    return URL.createObjectURL(data);
  },

  /** Download any attachment (auth-protected) under its original filename. */
  downloadAttachment: async (url, filename) => {
    const { data } = await axiosPrivate.get(url, { responseType: "blob" });
    const objectUrl = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
  },
};

export default employeeRequestService;
